<template>
  <v-dialog v-model="dispositionHistoryDialog" persistent max-width="850">
    <v-card v-if="dispositionHistory">
      <v-card-title class="headline">
        {{ $t("card.memo-disposition-history") }}
      </v-card-title>
      <v-card-text class="pa-2">
        <v-tabs v-model="tab" color="primary accent-4">
          <v-tabs-slider></v-tabs-slider>

          <v-tab href="#tab-1">
            <v-icon class="mr-2">{{ iconDisposition }}</v-icon>
            {{ $t("tab.delegation-info") }}
          </v-tab>

          <v-tab href="#tab-2">
            <v-icon class="mr-2">{{ iconTracking }}</v-icon>
            {{ $t("tab.tracking-info") }}
          </v-tab>

          <v-tab href="#tab-3">
            <v-icon class="mr-2">{{ iconFeedback }}</v-icon>
            {{ $t("tab.feedback") }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" touchless>
          <v-tab-item value="tab-1">
            <v-card flat class="no-box-shadow table-responsive-container">
              <v-card-text class="table-responsive"
                ><p
                  class="mb-2 text--bold"
                  v-html="$t('label.to-whom-this-memo-has-dispositioned')"
                ></p>
                <table width="100%" class="table-align-top">
                  <tr>
                    <td width="20%">{{ $t("label.sending-at") }}</td>
                    <td width="1%">:</td>
                    <td width="79%" style="cursor: pointer">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-on="on" v-bind="attrs">{{
                            $date(dispositionHistory.created_at).format(
                              "DD MMMM YYYY HH:mm WIB"
                            )
                          }}</span>
                        </template>
                        <span>{{
                          timeAgo(dispositionHistory.created_at)
                        }}</span>
                      </v-tooltip>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("label.disposition-recipients") }}</td>
                    <td>:</td>
                    <td>
                      <ol class="pl-4">
                        <li
                          v-for="item in dispositionHistory.recipients"
                          :key="item.id"
                        >
                          {{ item.nama }}
                          <v-tooltip bottom v-if="item.readed_at">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-on="on"
                                v-bind="attrs"
                                class="success--text"
                                >{{ iconEye }}</v-icon
                              >
                            </template>
                            <span>{{
                              $t("tooltip.has-read-by-disposition-recipient")
                            }}</span>
                          </v-tooltip>
                        </li>
                      </ol>
                    </td>
                  </tr>
                </table>
                <p class="mb-2 mt-8 text--bold">
                  {{ $t("label.disposition-selected-message") }}
                </p>
                <table width="100%" class="table-align-top">
                  <tr>
                    <td width="20%">{{ $t("label.urgency-level") }}</td>
                    <td width="1%">:</td>
                    <td width="79%">
                      {{ urgencyLevel(dispositionHistory.urgensi) }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("label.disposition-messages") }}</td>
                    <td>:</td>
                    <td style="cursor: pointer">
                      <ul
                        style="list-style-type: none"
                        class="pl-0 history--list-checkbox"
                      >
                        <li
                          v-for="(item, idx) in dispositionHistory.messages"
                          :key="idx"
                        >
                          <v-icon class="mr-2">{{ iconCheck }}</v-icon
                          ><span>{{ item }}</span>
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("label.additional-comment") }}</td>
                    <td>:</td>
                    <td>{{ dispositionHistory.comment }}</td>
                  </tr>
                </table>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item value="tab-2">
            <v-card flat class="no-box-shadow">
              <v-card-text>{{
                $t("label.where-the-disposition-now")
              }}</v-card-text>
              <tracking-disposition></tracking-disposition>
            </v-card>
          </v-tab-item>
          <v-tab-item value="tab-3">
            <v-card flat class="no-box-shadow">
              <v-card-text
                v-if="dispositionFeedbacks && dispositionFeedbacks.length > 0"
              >
                <p>
                  {{ $t("label.feedback-if-done") }}
                </p>
                <table border="1" class="table__permit-history" width="100%">
                  <tr>
                    <th class="px-1 py-1">
                      {{ $t("text.disposition-recipient") }}
                    </th>
                    <th class="px-1 py-1">{{ $t("text.feedback-comment") }}</th>
                  </tr>
                  <tr v-for="item in dispositionFeedbacks" :key="item.nik">
                    <td class="px-1 py-1 text-justify" style="cursor:pointer;">
                      <v-tooltip
                        bottom
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <span v-on="on" v-bind="attrs">{{
                            item.creator
                          }}</span>
                        </template>
                        <span>{{ $t('tooltip.dispositioned-by')+' '+item.atasan_langsung }}</span>
                      </v-tooltip>
                    </td>
                    <td class="px-1 py-1 text-justify"  style="cursor:pointer;">
                       <v-tooltip
                        bottom
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <span v-on="on" v-bind="attrs">{{
                            item.feedback
                          }}</span>
                        </template>
                        <span>{{ $t('tooltip.feedback-at')+' '+$date(item.updated_at).fromNow() }}</span>
                      </v-tooltip>
                      </td>
                  </tr>
                </table>
              </v-card-text>
              <v-card-text v-else
                ><p class="text-center py-2">
                  {{ $t("text.feedback-is-empty") }}
                </p></v-card-text
              >
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>

      <v-card-actions class="pb-4">
        <v-spacer></v-spacer>
        <v-btn
          outlined
          color="red darken-1"
          @click="dispositionHistoryDialog = false"
        >
          <v-icon class="mr-2">{{ iconClose }}</v-icon>
          {{ $t("button.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card v-else>
      <v-skeleton-loader
        class="mx-auto"
        max-width="100%"
        type="article, actions"
      ></v-skeleton-loader>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapState } from "vuex";
import {
  mdiAccountArrowRightOutline,
  mdiMapSearchOutline,
  mdiCommentQuoteOutline,
  mdiCheck,
  mdiEyeOutline,
  mdiClose,
} from "@mdi/js";
import TrackingDisposition from "./detailComponents/TrackingDisposition.vue";

export default {
  name: "disposition-history-modal",
  components: {
    TrackingDisposition,
  },
  props: {
    memoId: { type: String },
    dispositionId: { type: String },
  },
  data: () => ({
    iconDisposition: mdiAccountArrowRightOutline,
    iconTracking: mdiMapSearchOutline,
    iconFeedback: mdiCommentQuoteOutline,
    iconCheck: mdiCheck,
    iconEye: mdiEyeOutline,
    iconClose: mdiClose,
    dispositionRecipients: [],
    tab: 0,
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  }),
  computed: {
    ...mapState("inbox", ["dispositionHistoryDetail"]),
    ...mapState("disposition", ["dispositionFeedbacks"]),
    ...mapState(["networkError"]),
    dispositionHistory() {
      if (!this.dispositionHistoryDetail) return undefined;
      return this.dispositionHistoryDetail;
    },
    // dispositionId() {
    //   if (!this.delegationHistory || !this.delegationHistory[0] ) return null;
    //   return this.delegationHistory[0].id_hash;
    // },
    dispositionHistoryDialog: {
      get() {
        return this.$store.state.inbox.dispositionHistoryDialog;
      },
      set(val) {
        this.$store.commit("inbox/SET_DISPOSITION_HISTORY_DIALOG", val);
      },
    },
  },
  watch: {
    dispositionHistoryDialog(val) {
      if (!val || !this.dispositionId || !this.memoId) return;
      this.loadDispositionDetail();
      this.tab = 0;
    },
    memoId(val) {
      if (!val || !this.dispositionId || !this.dispositionHistoryDialog) return;
      this.loadDispositionDetail();
    },
  },
  methods: {
    ...mapActions("inbox", [
      "getDispositionDetail",
      "setDispositionHistoryDialog",
    ]),
    ...mapActions("disposition", [
      "getDispositionTrack",
      "getDispositionFeedbacks",
    ]),
    loadDispositionDetail() {
      this.getDispositionDetail({
        memoId: this.memoId,
        dispositionId: this.dispositionId,
      });
      this.getDispositionTrack({ memoId: this.memoId });
      this.getDispositionFeedbacks({
        memoId: this.memoId,
        dispositionId: this.dispositionId,
      });
    },
    urgencyLevel(val) {
      let intVal = parseInt(val);
      let result = "direct";
      switch (intVal) {
        case 1:
          result = "direct";
          break;
        case 2:
          result = "normal";
          break;
        case 3:
          result = "urgent";
          break;
        case 4:
          result = "very-urgent";
          break;
        default:
          result = "direct";
          break;
      }
      return this.$t("label." + result);
    },
  },
};
</script>
<style lang="scss">
.no-shadow {
  box-shadow: none !important;
}
</style>